export enum UserDetailsTableProps {
  NAME_TITLE = 'Name',
  NAME_DATA_INDEX = 'name',
  ROLE_TITLE = 'Role',
  ROLE_INDEX = 'userRole',
  EMAIL_TITLE = 'Email',
  EMAIL_INDEX = 'email',
  PHONE_TITLE = 'Phone number',
  PHONE_INDEX = 'phone',
  BRAND = 'Brand',
  BRAND_INDEX = 'association',
  ACTION_TITLE = '',
  ACTION_INDEX = 'actions',
  ACTION_WIDTH = '10%',
}

export enum UserDetailsProps {
  LOADING_INDICATOR = 'Loading...',
  DELETE_ICON_ALT = 'delete',
  EDIT_ICON_ALT = 'edit',
}
